import application from './application'
import system from './system'
import location from './location'

export default {
  ...application,
  ...system,
  ...location
}
